import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import NavHeader from "../shared/components/NavHeader";
import GuestSearchBar from "../shared/components/GuestSearchBar";
import ExistingMatchesSection from "./components/ExistingMatchesSection";
import GuestListSection from "./components/GuestListSection";
import CreateSetupButton from "./components/CreateSetupButton";
import ManualMatchStore from "./store/manualMatchStore";
import EventStore from "../event/store/eventStore";

interface ManualMatchPageProps {
  onBack: () => void;
}

const ManualMatchPageComponent: React.FC<ManualMatchPageProps> = ({
  onBack,
}) => {
  useEffect(() => {
    if (EventStore.sitchEventData?.guid) {
      ManualMatchStore.loadAttendees(EventStore.sitchEventData.guid);
    }
    if (EventStore.sitchEventData?.current_round) {
      ManualMatchStore.loadCandidates(EventStore.sitchEventData.current_round);
    }
  }, [
    EventStore.sitchEventData?.guid,
    EventStore.sitchEventData?.current_round,
  ]);

  return (
    <div className="min-h-screen bg-black text-white">
      <NavHeader onBack={onBack} />

      <div className="max-w-md mx-auto px-6 py-6 pb-24">
        {ManualMatchStore.candidates.length > 0 ? (
          <>
            <ExistingMatchesSection
              manualMatches={ManualMatchStore.candidates}
              onRemoveMatch={ManualMatchStore.removeManualMatch}
            />

            <div className="mb-6">
              <h2 className="text-3xl font-nostalgic mb-4">
                Continue manually setting up...
              </h2>
              <p className="text-white/70 text-sm mb-6">
                Manually setting someone up doesn't remove them from the
                available pool or prevent them from getting more setups.
              </p>

              <GuestSearchBar
                value={ManualMatchStore.searchQuery}
                onChange={ManualMatchStore.setSearchQuery}
                placeholder="Search guests here..."
              />
            </div>
          </>
        ) : (
          <div className="mb-6">
            <h2 className="text-4xl font-nostalgic mb-4">
              Choose two guests to manually setup.
            </h2>
            <p className="text-white/70 text-sm mb-6">
              Manually setting someone up doesn't remove them from the available
              pool or prevent them from getting more setups.
            </p>

            <GuestSearchBar
              value={ManualMatchStore.searchQuery}
              onChange={ManualMatchStore.setSearchQuery}
              placeholder="Search guests here..."
            />
          </div>
        )}

        <GuestListSection
          guests={ManualMatchStore.filteredAttendees}
          selectedGuests={ManualMatchStore.selectedGuests}
          onGuestToggle={ManualMatchStore.toggleGuestSelection}
          searchQuery={ManualMatchStore.searchQuery}
        />

        <CreateSetupButton
          onCreateSetup={ManualMatchStore.createManualSetup}
          visible={ManualMatchStore.selectedGuests.length >= 2}
        />
      </div>
    </div>
  );
};

const ManualMatchPage = observer(ManualMatchPageComponent);

export default ManualMatchPage;
